import { z } from "zod";

export const sessionItemSchema = z.object({
  id: z.string(),
  userAgent: z.string().nullable(),
  ip: z.string().nullable(),
  createdAt: z.date(),
  lastSeenAt: z.date(),
  isCurrent: z.boolean(),
});

export const sessionListSchema = z.object({
  items: z.array(sessionItemSchema),
});

export type SessionItem = z.infer<typeof sessionItemSchema>;
export type SessionList = z.infer<typeof sessionListSchema>;
